import React from 'react';

import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { useDispatch } from 'react-redux';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getLanguageSelector,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onLanguageSelectorChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';

import { Input } from '@/src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  errKey,
  validateLanguageSelector,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/tools';
import { store } from 'src/store';
import {
  generalValuePickerAccordingLanguage,
  getI18nFromGeneral,
  i18nGet,
} from 'src/tools/tools';
const LanguageSelector = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const d = useDispatch();
  const { data, specificError } = props;
  const titleErr = specificError[errKey.languageSelectorTitle];
  //console.log('language titleErr', titleErr);
  const { title } = data || {};
  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={`${getI18n(
            'salesChannelContent.index.languageSelectorTitle',
          )}*`}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            maxLength={100}
            error={(titleErr || []).length > 0}
            help={(titleErr || []).join(' ')}
            size='large'
            value={title}
            onChange={(title) => {
              d(onLanguageSelectorChange(title));
            }}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(LanguageSelector, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.languageSelector,
  getContent: getLanguageSelector,
  title: getI18nFromGeneral('general.hOCTitle.languageSelector'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  expandOffset: 0,
  getSubmitStamp,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateLanguageSelector(x, isPrimary);
  },
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          const text = generalValuePickerAccordingLanguage({
            cn: '语言',
            hk: '語言',
            gb: 'Language',
          });

          store.dispatch(onLanguageSelectorChange(text));
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
